import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      ref={ref}
      id="about"
      className="py-24 md:py-32 bg-brand-softBeige overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="image-zoom rounded-2xl overflow-hidden">
              <img
                src="/images/0b159536-ab30-4b01-b82e-a5594b00a9f7.jpg"
                alt="Natural hair care routine with tropical botanicals"
                loading="lazy"
                className="w-full h-[500px] lg:h-[600px] object-cover"
                onLoad={(e) => e.target.classList.add("loaded")}
              />
            </div>
            {/* Decorative Frame */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-brand-warmGold/30 rounded-2xl -z-10" />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:pl-8"
          >
            <span className="text-brand-warmGold text-xs tracking-[0.3em] uppercase font-body block mb-4">
              Our Philosophy
            </span>
            <h2 className="font-heading text-4xl sm:text-5xl font-light text-brand-deepGreen mb-6 leading-tight">
              Rooted in Nature.
              <br />
              Made with Purpose.
            </h2>
            <div className="section-divider mb-8" />
            <p className="text-brand-coconutBrown/80 text-base sm:text-lg font-body font-light leading-relaxed mb-6">
              Our oils and grease are made for people who want more than just
              hair products — they want a healthy routine. Whether you are
              wearing your hair natural, protective styles, braids, or locs,
              Pure Intentional helps you care for your hair with purpose.
            </p>
            <p className="text-brand-coconutBrown/80 text-base sm:text-lg font-body font-light leading-relaxed mb-8">
              Every ingredient is carefully selected to nourish your scalp and
              strengthen your strands. We believe in the power of nature and the
              beauty of intentional self-care.
            </p>
            <a
              href="#contact"
              className="btn-primary inline-block"
              data-testid="about-cta"
            >
              Get in Touch
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
